const domain = process.env.REACT_APP_API_DOMAIN_DLGO;
export const Urls = {
  api: {
    paymentInfo: `${domain}/v1/checkout/`,
    dataRequired: `${domain}/v1/checkout/payment_method/`,
    confirmPayment: `${domain}/v1/checkout/confirm`,
    shopifyStatus: `${domain}/v1/checkout/shopify/success`,
    selectCountry: `${domain}/v1/checkout/country/:country`,
  },
  paymentMethodsSquare: 'https://static.directopago.com/payment_method/square/:code.svg',
  paymentMethodsWide: 'https://static.directopago.com/payment_method/wide/:code.png',
  flags: 'https://static.directopago.com/flags/:code.svg',
  externals: {
    dlocal: 'https://dlocal.com/',
    customerSupport: 'https://support.dlocal.com/',
  },
};
